import { axiosInstanceWebsite } from "@/services/instance";
import type {
  CreativesWebsitesResponse,
  FunnelCreativesResponse,
  CreativesResponse,
  ProductsInfoCreativeResponse,
} from "../types/creatives.types";

function normalizeCreativesWebsitesResponse(
  data: any
): CreativesWebsitesResponse {
  if (Array.isArray(data)) return data as CreativesWebsitesResponse;
  if (Array.isArray(data?.data)) return data.data as CreativesWebsitesResponse;
  return [];
}

function normalizeFunnelCreativesResponse(data: any): FunnelCreativesResponse {
  if (Array.isArray(data)) return data as FunnelCreativesResponse;
  if (Array.isArray(data?.data)) return data.data as FunnelCreativesResponse;
  return [];
}

function normalizeCreativesResponse(data: any): CreativesResponse {
  if (Array.isArray(data)) return data as CreativesResponse;
  if (Array.isArray(data?.data)) return data.data as CreativesResponse;
  return [];
}

function normalizeProductsInfoCreativeResponse(
  data: any
): ProductsInfoCreativeResponse {
  if (Array.isArray(data)) return data as ProductsInfoCreativeResponse;
  if (Array.isArray(data?.data)) return data.data as ProductsInfoCreativeResponse;
  return [];
}

export const creativesService = {
  async listWebsites(): Promise<CreativesWebsitesResponse> {
    const response = await axiosInstanceWebsite.get(`/ads/creatives/websites`);
    return normalizeCreativesWebsitesResponse(response.data);
  },

  async listByWebsiteId(websiteId: string): Promise<FunnelCreativesResponse> {
    const response = await axiosInstanceWebsite.get(
      `/ads/creatives/websites/${websiteId}`
    );
    return normalizeFunnelCreativesResponse(response.data);
  },

  async listByProductId(productId?: string): Promise<CreativesResponse> {
    const params = productId ? { product_id: productId } : {};
    const response = await axiosInstanceWebsite.get(`/ads/creatives`, {
      params,
    });
    return normalizeCreativesResponse(response.data);
  },

  async listProducts(): Promise<ProductsInfoCreativeResponse> {
    const response = await axiosInstanceWebsite.get(`/ads/creatives/products`);
    return normalizeProductsInfoCreativeResponse(response.data);
  },
};
